export enum PaymentMethodStatus {
    ACTIVE = 'active',
    DISABLED = 'disabled',
    FAILED = 'failed'
}
